import { LayoutGrid, Table2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import type { UsersPageViewMode } from "../usersPage.constants";

interface UsersViewToggleProps {
  viewMode: UsersPageViewMode;
  onViewModeChange: (viewMode: UsersPageViewMode) => void;
}

export function UsersViewToggle({ viewMode, onViewModeChange }: UsersViewToggleProps) {
  return (
    <div className="inline-flex rounded-lg border border-border bg-card p-0.5">
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={() => onViewModeChange("table")}
        className={cn("h-8 gap-1.5", viewMode === "table" && "bg-surface-subtle text-foreground")}
      >
        <Table2 size={13} />
        Tableau
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={() => onViewModeChange("grid")}
        className={cn("h-8 gap-1.5", viewMode === "grid" && "bg-surface-subtle text-foreground")}
      >
        <LayoutGrid size={13} />
        Grille
      </Button>
    </div>
  );
}
